import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RedirectService {
    private componentRedirect: string | null = null;
    private bookingId: string | null = null;

    setRedirectComponent(component: string) {
        this.componentRedirect = component;
    }

    setRedirectBookingId(bookingId: string) {
        this.bookingId = bookingId;
    }

    consumeRedirectComponent(): { component: string | null; bookingId: string | null } {
        const result = { component: this.componentRedirect, bookingId: this.bookingId };
        this.componentRedirect = null;
        this.bookingId = null;
        return result;
    }
}